import BaseService from './BaseService'

class ProjectService extends BaseService {
  constructor () {
    super('/projects')
  }

  getSummary (projectId) {
    return this.customRequest('get', `/${projectId}/summary`)
  }

  listInvoices (projectId, params = {}) {
    return this.customRequest('get', `/${projectId}/invoices`, null, { params })
  }

  linkInvoices (projectId, invoiceIds) {
    return this.customRequest('post', `/${projectId}/invoices/link`, { invoice_ids: invoiceIds })
  }

  unlinkInvoices (projectId, invoiceIds) {
    return this.customRequest('post', `/${projectId}/invoices/unlink`, { invoice_ids: invoiceIds })
  }
}

export default new ProjectService()
